/**
 * Rollenmodell laut 01_roles_and_accounts.md.
 *
 * Es gibt bewusst kein feingranulares Rechtesystem in V1.
 * Der Hauptadmin liegt ausserhalb der Mandanten (`platform_admins`).
 */
export const TENANT_ROLE = {
  /** Kundenadmin: darf Caller, Kampagnen und Guthaben verwalten. */
  ADMIN: 'admin',
  /** Caller: Telefonieoberflaeche, darf Kundendaten korrigieren. */
  CALLER: 'caller',
} as const;

export type TenantRole = (typeof TENANT_ROLE)[keyof typeof TENANT_ROLE];

export const SUPPORTED_LOCALES = ['de', 'en', 'tr'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

/** Standardsprache neuer Kunden laut 02_navigation_ux_tutorial_i18n.md. */
export const DEFAULT_LOCALE: Locale = 'de';

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
